import { Tooltip } from 'antd';
import { useContext, useEffect, useRef } from 'react';

import { Button, OfferCard } from '@/components/Shared/ui';
import { BANKS_ICONS_NAMES, DictTypes } from '@/constants';
import { ReloadOutlined } from '@/media/antd-icons';
import { useAppSelector } from '@/store';

import { OfferStepContext } from '../../offer-step';
import type { TBankOffers } from '../../types/bank-offer.types';

interface IProps {
  bankOffer: TBankOffers;
}

const ForteWaitingItem: React.FC<IProps> = ({ bankOffer }) => {
  const { handleChangeForteStatus, updateResponses } =
    useContext(OfferStepContext);
  const { dicts } = useAppSelector((state) => state.dict);
  const forteTimeout = useRef<NodeJS.Timeout | null>(null);

  const bank = dicts?.[DictTypes.Banks]?.getBy.name[bankOffer.bank.name];
  const bankIconName = BANKS_ICONS_NAMES[bankOffer.bank.name];

  const onUpdateForteStatus = async () => {
    if (bankOffer?.extId !== null) {
      if (forteTimeout.current) clearTimeout(forteTimeout.current);
      const shouldUpdateResponses = await handleChangeForteStatus(
        bankOffer.extId
      );
      if (shouldUpdateResponses) updateResponses(true);
    }
  };

  useEffect(() => {
    forteTimeout.current = setTimeout(async () => {
      if (bankOffer?.extId !== null) {
        const shouldUpdateResponses = await handleChangeForteStatus(
          bankOffer.extId
        );
        if (shouldUpdateResponses) updateResponses(true);
      }
    }, 60000);
    return () => {
      if (forteTimeout.current) clearTimeout(forteTimeout.current);
    };
  }, [bankOffer?.extId]);

  const headerActions: React.ReactElement[] = [];
  if (bankOffer?.extId !== null)
    headerActions.push(
      <Tooltip key={bankOffer.extId + 'status-button'} title="Обновить статус">
        <Button isSquare size="small" onClick={onUpdateForteStatus}>
          <ReloadOutlined className="forte-bank-item__icon" />
        </Button>
      </Tooltip>
    );

  const name = bank?.fullname || bankIconName?.name;
  const icon = bank?.icon || bankIconName?.icon;

  if (!name) return null;
  return (
    <OfferCard
      className="bank-item"
      status="warning"
      statusText={bankOffer.status.name}
      extId={bankOffer.extId || undefined}
    >
      <OfferCard.Header
        title={name}
        icon={icon}
        isWaitingOffer
        headerActions={headerActions}
        requestBodyInfo={{
          bankName: bankOffer.bank.name,
          responsePrimaryBody: bankOffer.responsePrimaryBody,
          responseSendedBody: bankOffer.responseSendedBody
        }}
      />
    </OfferCard>
  );
};

export default ForteWaitingItem;
